export const getPriceLabelSuffix = (
  showDailyRate: boolean,
  dayLabel?: string,
): string => {
  return showDailyRate && dayLabel ? `/${dayLabel}` : '';
};
